import React, { useEffect, useState } from "react";
import WmsCheckBox from "../../components/WmsCheckBox/WmsCheckBox";
import "./audit-inventory-review-audit-job-grid.scss";
import WmsButton from "../../components/WmsButton/WmsButton";
import VirtualGridComponent from "../../components_proto/VirtualGridComponent/VirtualGridComponent";
import { AddEditColumnModel } from "../../components/AddEditColumn/add-edit-columns.component";
import {
    reviewAuditJobGridColumns,
    reviewAuditJobGridSchema,
} from "./audit-inventory-review-audit-job-grid-configuration";
import { StringWms } from "../../../../assets/ts/StringWms";
import {
    GetAuditReviewList,
    GetAuditReviewCSV,
    RecountAll,
    RecountLocationsAndTrackBys,
} from "./review-audit-job.service";
import * as GlobalService from "../../global_services";
import _ from "lodash";
import PropTypes from "prop-types";
import WmsToolTip from "../../components/WmsToolTip/WmsToolTip";
import * as auditInventoryServices from "./../audit-inventory.services";
import { ArrayWms } from "../../../../assets/ts/ArrayWms";
import MultiLineEllipsis from "../../components/MultiLineEllipsis/multi-line-ellipsis";

interface Props {
    wmsSelector: string;
    auditCountsUris: Array<string>;
    auditCountsEditUris: Array<string>;
    reviewAuditJobTitle: string;
    facilityUri: string;
    mainGridSelectedRowData: any;
    sendSubGridSelectedDataToModalComponent: any;
    getAuditOptions: any;
    onReviewAuditJobModalClose: any;
    windowId: any;
}

declare var window: any;
let localKendoGrid = null;

const AuditInventoryReviewAuditJobGrid: React.FC<Props> = (props: Props) => {
    const [showVariancesOnly, setShowVariancesOnly] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [originalResponseData, setOriginalResponseData] = useState([]);
    const itemName = props.mainGridSelectedRowData?.Sku !== "" ? props.mainGridSelectedRowData.Sku : "";
    const [exportLoading, setExportLoading] = useState(false);

    const defaultColumns = reviewAuditJobGridColumns(
        StringWms.convertSringToOption(window.translate("Audit_Inventory_Review_Audit_Job_GrideHeaders"))
    );
    const allColumnList = reviewAuditJobGridColumns(
        StringWms.convertSringToOption(window.translate("Audit_Inventory_Review_Audit_Job_GrideHeaders"))
    );
    const gridId = props.wmsSelector + "ReviewAuditJobGrid";
    const [schema] = useState(reviewAuditJobGridSchema);
    const gridDomSelector = "#" + gridId;
    const [gridConfig] = useState(auditInventoryServices.getAuditInventoryreviewGridOptionInMetaData());
    const [recordsCount, setRecordsCount] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [fullFilterText, setFullFilterText] = useState("");
    const [isOpenColumnModal, setIsOpenColumnModal] = useState(false);
    const [isGridDataLoading, setIsGridDataLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsGridDataLoading(true);
            // setGridConfig(auditInventoryServices.getAuditInventoryreviewGridOptionInMetaData());
            const reviewAuditJobResponse = await GetAuditReviewList(props.auditCountsUris);
            if (reviewAuditJobResponse.status) {
                setOriginalResponseData(reviewAuditJobResponse.data.AuditReviews);
                arrangeAndSetGridData(reviewAuditJobResponse.data.AuditReviews);
            }
            setIsGridDataLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        sendSubGridSelectedDataToModalComponent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gridData]);
    const sendSubGridSelectedDataToModalComponent = () => {
        const selectedGridValues = localKendoGrid?.getValues() || [];
        const selectedRowIds = selectedGridValues.map((obj: any) => obj.detailId).filter(Boolean);

        // Get variance data
        const varianceData = gridData
            .filter(
                (item) =>
                    item.variance && typeof item.variance === "number" && !isNaN(item.variance) && item.variance !== 0
            )
            .map((item) => item.detailId);

        let disableRecouncleButton = false;
        let isNotCountedRow = false;
        let isAnyselectedRowsHasTrackbysRow = localKendoGrid?.getValues().some((el) => el.hasTrackbys);

        // Create a map for O(1) lookup instead of O(n) searches
        const gridDataMap = new Map(gridData.map((item) => [item.detailId, item]));

        // Analyze selected rows in a single pass
        const selectedRowAnalysis = selectedRowIds.reduce(
            (acc, rowId) => {
                const gridItem = gridDataMap.get(rowId);
                if (gridItem) {
                    const isNotCounted = gridItem.physicalCount === 0 && gridItem.locationEmpty === false;
                    const isCounted = gridItem.physicalCount > 0;

                    if (isNotCounted) {
                        acc.notCountedRows.push(rowId);
                        isNotCountedRow = true;
                    }
                    if (isCounted) {
                        acc.countedRows.push(rowId);
                    }
                }
                return acc;
            },
            { notCountedRows: [], countedRows: [] }
        );

        // Disable reconcile button only if we have "Not Counted" rows but no corresponding "Counted" rows
        // This prevents reconciliation of standalone "Not Counted" items without a corresponding adjustment
        if (selectedRowAnalysis.notCountedRows.length > 0 && selectedRowAnalysis.countedRows.length === 0) {
            disableRecouncleButton = true;
        }

        const allVarianceInData = varianceData.every((item) => selectedRowIds.includes(item));

        props.sendSubGridSelectedDataToModalComponent(
            selectedRowIds,
            disableRecouncleButton,
            isAnyselectedRowsHasTrackbysRow,
            isNotCountedRow,
            allVarianceInData || varianceData.length === 0
        );
    };

    useEffect(() => {
        let tempGridData: Array<any> = originalResponseData;
        if (showVariancesOnly === true) {
            tempGridData = Object.assign(
                [],
                originalResponseData.filter((grid: any) => {
                    return grid.variance !== 0 || grid.parentId === null;
                })
            );
        }
        setIsGridDataLoading(true);
        arrangeAndSetGridData(tempGridData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showVariancesOnly]);

    const arrangeAndSetGridData = (auditReview: any) => {
        let auditReviews: Array<any> = _.cloneDeep(auditReview);
        let removeAuditReviewIds: Array<number> = [];
        auditReviews.forEach((mainReview) => {
            auditReviews.forEach((childReview) => {
                if (mainReview.id === childReview.parentId) {
                    removeAuditReviewIds.push(childReview.id);
                    if (mainReview?.childReview === undefined) {
                        mainReview.childReview = [];
                    }
                    childReview.resetUri = mainReview.resetUri;
                    mainReview.childReview.push(childReview);
                }
            });
        });
        let filteredAuditReviewstemp = auditReviews.filter((review) => !removeAuditReviewIds.includes(review.id));
        let filteredAuditReviews = [];
        // remove auditNodeType =1 object, show auditNodeType = 2 as chieldRow of review.
        filteredAuditReviewstemp.forEach((el) => {
            if (el.childReview) {
                var nodeType2Data = [];
                el.childReview.forEach((chEl) => {
                    nodeType2Data = [...nodeType2Data, ...chEl.childReview];
                });
                nodeType2Data.forEach((chEl) => {
                    filteredAuditReviews.push({
                        id: chEl.id,
                        RowNumber: chEl.id,
                        ItemName: chEl?.skuble?.Sku,
                        Location: el.title,
                        Customer: chEl?.skuble?.CustomerName,
                        MovableUnit: chEl?.skuble?.PalletName,
                        SystemQty: chEl?.systemCount,
                        AllocatedQty: chEl?.allocatedCount,
                        CountedQty:
                            chEl?.physicalCount === 0 && chEl?.locationEmpty === false
                                ? "Not counted"
                                : chEl?.physicalCount,
                        Variance: chEl?.variance,
                        AuditType: props.mainGridSelectedRowData.AuditType,
                        IsSelectable: true,
                        ...chEl,
                    });
                });
            }
        });
        setGridData(filteredAuditReviews);
        setRecordsCount(filteredAuditReviews.length);
        setIsGridDataLoading(false);
    };

    const handleShowVariancesOnly = (e: any) => {
        props.sendSubGridSelectedDataToModalComponent([], true);
        setShowVariancesOnly(e.target.checked);
    };

    const exportGridToCsv = () => {
        setExportLoading(true);
        GetAuditReviewCSV(props.auditCountsUris)
            .then(function (response) {
                var now = new Date();
                var headers = response.headers;
                GlobalService.downloadFileBaseOnContentType(
                    response.data,
                    headers["content-type"],
                    itemName +
                        "_" +
                        +(now.getMonth() + 1) +
                        "-" +
                        +now.getDate() +
                        "-" +
                        +now.getFullYear() +
                        "_" +
                        +now.getHours() +
                        "_" +
                        now.getMinutes() +
                        ".csv",
                    true,
                    "download"
                );
                setExportLoading(false);
            })
            .finally(function () {
                setExportLoading(false);
            });
    };

    const clickEventOfContextMenu = (obj: any) => {
        if (obj.wmsid === "recountJob") {
            recountJob();
        } else if (obj.wmsid === "recountJobTrackBys") {
            recountJobTrackBysOrLocations(true);
        } else if (obj.wmsid === "recountLocations") {
            recountJobTrackBysOrLocations(false);
        }
    };
    const recountJob = () => {
        RecountAll(props.auditCountsUris).then(
            function (response) {
                if (response.status === 204) {
                    GlobalService.notification("success", window.translate("Recount_Audit_Success"));
                    props.onReviewAuditJobModalClose();
                    props.getAuditOptions(props.facilityUri);
                }
            },
            function (response) {
                // GlobalService.notification('error', response);
            }
        );
    };
    const recountJobTrackBysOrLocations = (allowTrackBys) => {
        var resetUris = [];
        if (allowTrackBys) {
            gridData.map((row: any) => {
                if (resetUris.indexOf(row.resetUri) === -1) {
                    resetUris.push(row.resetUri);
                }
                return null;
            });
        } else {
            const selectedRowIds = localKendoGrid.getKeys();
            gridData.forEach((element) => {
                if (
                    selectedRowIds.includes(element.detailId.toString()) &&
                    resetUris.indexOf(element.resetUri) === -1
                ) {
                    resetUris.push(element.resetUri);
                }
            });
        }
        RecountLocationsAndTrackBys(resetUris, props.auditCountsEditUris, allowTrackBys).then(
            function (res) {
                if (res.status === 204) {
                    GlobalService.notification("success", window.translate("Recount_Audit_Success"));
                    props.onReviewAuditJobModalClose();
                    props.getAuditOptions(props.facilityUri);
                }
            },
            function (res) {
                // GlobalService.notification('error', response);
            }
        );
    };

    const onGridDataBound = (e, kendoGrid) => {
        localKendoGrid = kendoGrid;
    };
    // on grid filter selection
    const onGridFilterApplied = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var dataSource = grid.dataSource;
        setTimeout(() => {
            let filter = dataSource.filter();
            var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
            var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sortArray, filter);
            auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
            setFilterAppliedText(filter);
        }, 50);
    };
    const setFilterAppliedText = (filterObj) => {
        if (!filterObj) {
            setFilterText("");
            setFullFilterText("");
            return;
        }
        var filterConditionTitle = {
            lte: "Is Less Than Or Equal To",
            eq: "Is Equal To",
            lt: "Is Less Than",
            neq: "Is Not Equal To",
            gte: "Is Greater Than Or Equal To",
            gt: "Is Greater Than",
            startswith: "Starts With",
            endswith: "Ends With",
            contains: "Contains",
            doesnotcontain: "Does Not Contain",
            isnull: "Is Null",
            isnotnull: "Is Not Null",
            isempty: "Is Empty",
            isnotempty: "Is Not Empty",
            isnullorempty: "Has No Value",
            isnotnullorempty: "Has Value",
        };

        var filterText = "";
        var fullFilterText = "";
        var filterList = filterObj.filters;

        filterList.map((item) => {
            var title = allColumnList.find((x) => x.field === item.field).title;
            filterText += title + " : " + item.value + ",";
            fullFilterText += title + " " + filterConditionTitle[item.operator] + " : " + item.value + "<br>";
            return item;
        });
        filterText = filterText.slice(0, -1);
        setFilterText(filterText);
        setFullFilterText(fullFilterText);
    };
    // on grid column sort save changes in meta data object
    const onSort = (event) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        GlobalService.sortDataset(sortArray, event.sort);
        var gridColumn = grid.getOptions().columns;
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            gridColumn,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    // on grid column reorder save changes in meta data object
    const onColumnReorder = (event) => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let gridColumn = grid.getOptions().columns;
        let switchedArray = ArrayWms.switchIndexByField(gridColumn, event.newIndex, event.oldIndex);
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            switchedArray,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    // on grid column resize save changes in meta data object
    const onColumnResize = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(
            grid.columns,
            sortArray,
            grid.dataSource.filter()
        );
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    const onToggleColumnModal = (isOpen) => () => {
        setIsOpenColumnModal(isOpen);
    };
    // on click grid reset default grid layout menu
    const onClickResetGrid = () => {
        var finalSubmission = {
            optionsData: {},
        };
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    // on click grid clear sort menu
    const onClickClearSorts = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, [], grid.dataSource.filter());
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    const saveMetaData = () => {
        var grid = $(gridDomSelector).data("kendoGrid");
        var sort = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let finalSubmission = localKendoGrid.prepareGridOptionsForStorage(grid.columns, sort, grid.dataSource.filter());
        auditInventoryServices.setAuditInventoryreviewGridOptionInMetaData(finalSubmission);
    };
    const onSelection = (data) => {
        sendSubGridSelectedDataToModalComponent();
    };

    return (
        <div className={"audit-inventory-review-audit-job-grid " + props.windowId}>
            <div className="grid-options-wrapper">
                <div className="grid-options-left-part">
                    {props.mainGridSelectedRowData?.AuditType === "Item" && (
                        <div className="item-text">
                            <b>Item </b>
                            {itemName.toLocaleUpperCase()}
                        </div>
                    )}
                    {props.mainGridSelectedRowData?.Notes && props.mainGridSelectedRowData?.Notes !== "" && (
                        <div className="note-text">
                            <b>Notes </b>
                            <MultiLineEllipsis text={props.mainGridSelectedRowData?.Notes} lines={2} />
                        </div>
                    )}
                    <div>
                        <WmsCheckBox
                            id={"ShowVariancesOnly"}
                            name={"ShowVariancesOnly"}
                            label={window.translate("Label_Show_Variances_only")}
                            wmsSelector={gridId + "ShowVariancesOnlyCheckBox"}
                            checked={showVariancesOnly}
                            onChangeFunc={handleShowVariancesOnly}
                            parentClassName={"ShowVariancesOnlyCheckBox"}
                        />
                    </div>
                </div>
                <div>
                    <WmsToolTip
                        showToolTip={true}
                        tooltipText={window.translate("Tooltip_Text_Export_Adudit_Results_In_Csv")}
                    >
                        <WmsButton
                            id={gridId + "ExportReviewAuditJob"}
                            buttonType={"green"}
                            wmsSelector={gridId + "ExportReviewAuditJob"}
                            label={""}
                            icon={"fa-solid fa-file-export"}
                            onClickFunc={exportGridToCsv}
                            loading={exportLoading}
                            parentClassName={"export-review-audit-job"}
                            tooltipText={window.translate("Tooltip_Text_Export_Adudit_Results_In_Csv")}
                        />
                    </WmsToolTip>
                </div>
            </div>
            <hr />
            <div className={"audit-inventory-review-audit-job-grid-holder "}>
                <VirtualGridComponent
                    key={gridId + gridData.length}
                    id={gridId}
                    wmsSelector={props.wmsSelector + gridId}
                    loading={isGridDataLoading}
                    // windowId={props.windowId}
                    gridName={gridId}
                    gridKeySelection={"detailId"}
                    inlineSelectAll={false}
                    gridHeight={"500"}
                    allColumns={allColumnList}
                    defaultColumns={defaultColumns}
                    columns={defaultColumns}
                    schema={schema}
                    staticGridData={gridData}
                    virtual={false}
                    shawCheckbox={true}
                    isAlignIndexesByProperty={true}
                    onSelection={onSelection}
                    clickEventOfContextMenu={clickEventOfContextMenu}
                    resetButtonLabel={"Options"}
                    showGridSummary={true}
                    showResetButton={true}
                    onDataBound={onGridDataBound}
                    onClickResetGrid={onClickResetGrid}
                    eventClickColumns={onToggleColumnModal(true)}
                    showSortColumns={true}
                    showGridResult={true}
                    totalResult={recordsCount}
                    metaDataFieldsName={"reviewgridConfig"}
                    onGridFilterApplied={onGridFilterApplied}
                    filterText={filterText}
                    fullFilterText={fullFilterText}
                    onSort={onSort}
                    onColumnReorder={onColumnReorder}
                    onColumnResize={onColumnResize}
                    onClickClearSorts={onClickClearSorts}
                    metaGridConfig={gridConfig}
                    isAllDataLoad={true}
                    emptyRecoredText={window.translate("Window_Title_Label_Empty_Records")}
                    menu={[
                        {
                            name: window.translate("Recount_Review_Audit_Job"),
                            value: [],
                            disabled: false,
                            icon: "fa-plus",
                            color: "green",
                            isContextMenu: true,
                            isButtonMenu: false,
                            wmsid: "recountJob",
                            wmsSelector: gridId,
                            clickFunc: window.openAddAutoRateShoppingRuleModel,
                        },
                        {
                            name: window.translate("Recount_Review_Audit_Job_Track_Bys"),
                            value: [],
                            disabled: false,
                            icon: "fa-plus",
                            color: "green",
                            isContextMenu: true,
                            isButtonMenu: false,
                            wmsid: "recountJobTrackBys",
                            wmsSelector: gridId,
                            clickFunc: window.openAddAutoRateShoppingRuleModel,
                        },
                        {
                            name: window.translate("Recount_Review_Audit_Job_Locations"),
                            value: [],
                            disabled: false,
                            icon: "fa-plus",
                            color: "green",
                            isContextMenu: true,
                            isButtonMenu: false,
                            wmsid: "recountLocations",
                            wmsSelector: gridId,
                            clickFunc: window.openAddAutoRateShoppingRuleModel,
                        },
                    ]}
                />
            </div>
            {isOpenColumnModal && (
                <AddEditColumnModel
                    id={"addEditColumnEventNotification"}
                    height={700}
                    windowId={props.windowId}
                    onCloseColumnModel={onToggleColumnModal(false)}
                    isOpenColumnModel={isOpenColumnModal}
                    allSortColumnList={allColumnList}
                    gridId={gridId}
                    updateGridData={() => {}}
                    saveChangesInMetaData={saveMetaData}
                />
            )}
        </div>
    );
};

AuditInventoryReviewAuditJobGrid.propTypes = {
    wmsSelector: PropTypes.string.isRequired,
    auditCountsUris: PropTypes.arrayOf(PropTypes.string),
    reviewAuditJobTitle: PropTypes.string.isRequired,
    facilityUri: PropTypes.string.isRequired,
    mainGridSelectedRowData: PropTypes.object,
    sendSubGridSelectedDataToModalComponent: PropTypes.func,
    onReviewAuditJobModalClose: PropTypes.func,
    windowId: PropTypes.string.isRequired,
};

AuditInventoryReviewAuditJobGrid.defaultProps = {
    auditCountsUris: [],
    mainGridSelectedRowData: {},
    sendSubGridSelectedDataToModalComponent: () => {},
    onReviewAuditJobModalClose: () => {},
    windowId: "",
};
export default AuditInventoryReviewAuditJobGrid;
